import React, { useState } from 'react';
import styles from './Integrations.module.scss';
import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Integration } from 'js/constants/externalIntegrations';
import { ItemData } from 'new/components/settings/Integrations/IntegrationList/Item';
import { IconButton } from 'new/elements/IconButton';
import { IntegrationConfiguration } from './IntegrationConfiguration';

interface ConfigurationProps {
  integration: Integration;
  integrationType: string;
  onClose: () => void;
}

export const Configuration = ({ integration, integrationType, onClose }: ConfigurationProps) => {
  if (!integration) return null;
  const { longDescription } = integration.meta || {};

  return (
    <div className={styles.configuration}>
      <div className={styles.configurationsHeader}>
        {integration && <ItemData integration={integration} reverse />}
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className={styles.configurationContent}>
        <Typography variant="body3">{longDescription}</Typography>
      </div>
      <IntegrationConfiguration integration={integration} integrationType={integrationType} />
    </div>
  );
};
